import { ref, update } from "firebase/database";
import { database } from "./firebaseConfig";
import { getCurrentEventId, getCurrentUserId } from "../../helpers/reduxHelper";

const USER_PREFERENCES_PATH = "UserPreferences";

/**
 * Update preference for current user in firebase
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const updateEventUserPreference = async (data: any) => {
  // Get currently logged in user
  const loggedinUserId = getCurrentUserId();

  if (loggedinUserId) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    await updateEventPreferencesByUserId(loggedinUserId, data);
  }
};

export const updateEventPreferencesByUserId = async (
  userId: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any,
) => {
  const eventId = getCurrentEventId();

  if (eventId) {
    const dbRef = ref(
      database,
      `Event/${eventId}/${USER_PREFERENCES_PATH}/${userId}`,
    );

    await update(dbRef, data);
  }
};
